import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/hooks/useAuth";

interface ProtectedRouteProps {
  children: React.ReactNode;
}

export const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const { user, loading } = useAuth();

  if (!user && !loading) {
    return <Navigate to="/auth" replace />;
  }

  // If user exists but no tenant is selected, we still show the app
  // The tenant selection will be handled by the TenantProvider
  // Layout will handle the loading state during tenant initialization
  return <>{children}</>;
};